import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';

Vue.config.productionTip = false;
Vue.use(ElementUI);

axios.defaults.baseURL = '/api';
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
axios.interceptors.response.use((res) => {
  if (res.data && res.data.code === 401) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_id');
    localStorage.removeItem('admin_username');
    router.push('/login');
  }
  return res.data;
});

Vue.prototype.$http = axios;

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app');
